<script lang="ts">
import type { Component } from 'svelte'

import { DrawerId, type Drawers, openedDrawerId } from '@/modules/drawers'

import AuthFormDrawer from './authForm/AuthFormDrawer.svelte'
import ChatRatingDrawer from './chatRating/ChatRatingDrawer.svelte'
import CloseChatDrawer from './CloseChatDrawer.svelte'
import DrawerGdpr from './DrawerGdpr.svelte'
import DrawerOptions from './DrawerOptions.svelte'
import TicketFormDrawer from './ticketForm/TicketFormDrawer.svelte'

const drawers: Drawers = {
	[DrawerId.Options]: DrawerOptions,
	[DrawerId.GdprAndPrivacy]: DrawerGdpr,
	[DrawerId.AuthForm]: AuthFormDrawer,
	[DrawerId.CloseChat]: CloseChatDrawer,
	[DrawerId.ChatRating]: ChatRatingDrawer,
	[DrawerId.TicketForm]: TicketFormDrawer,
}

let openedDrawer: Component | null = $derived(
	typeof $openedDrawerId === 'number' ? drawers[$openedDrawerId] || null : null,
)
</script>

{#if openedDrawer}
	{@const SvelteComponent = openedDrawer}
	<SvelteComponent />
{/if}
